<template>
  <transition name="slide">
    <div v-show="isVisible && !isMobile" class="p-pageNavigation">
      <ul>
        <li 
          v-for="(section, i) in sections" 
          class="p-pageNavigation__item"
          :class="{
            'is-prev': i === prevIndex
          }" 
          :aria-selected="i === currentIndex">
          <a 
            href="#" 
            class="p-pageNavigation__anchor"
            @click.prevent="onClickAnchor(i)">
            <span class="p-pageNavigation__name" v-text="section"></span>
          </a>
        </li>
      </ul>
    </div>
  </transition>
</template>

<style scoped>
  .slide-enter-active,
  .slide-leave-active {
    transform: translate3d(0, 0, 0);
  }

  .slide-enter-active {
    transition: transform 1s cubic-bezier(0.165, 0.840, 0.440, 1.000); /* easeOutQuart */
  }

  .slide-leave-active {
    transition: transform 0.6s cubic-bezier(0.895, 0.030, 0.685, 0.220); /* easeInQuart */
  }

  .slide-enter, .slide-leave-to {
    transform: translate3d(5vw, 0, 0);
  }
</style>
  
<script>
  /**
   * Modules
   */
  import { mapGetters } from 'vuex'
  import SweetScroll from 'sweet-scroll'

  let scroller;

  /**
   * Share Partial
   */

  export default {
    name: 'page-navigation',
    props: {
      sections: {
        type: Array,
        // required: true
      }
    },
    computed: {
      isMobile() {
        return this.$window.viewport === 'mobile'
      },
      prevIndex() {
        return this.currentIndex - 1
      },
      ...mapGetters({
        'isVisible': 'pageNavigation/isVisible',
        'currentIndex': 'pageNavigation/currentIndex',
      }),
    },
    mounted() {
      // eslint-disable-next-line no-new
      scroller = new SweetScroll({
        easing: 'easeOutCirc'
      })
    },
    methods: {
      onClickAnchor(i) {
        scroller.to(`#section-${i}`)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/partial/page-navigation.vue